export const dataTablesAction = (node, data)=>{
    jQuery(()=>{
        var table = jQuery(node).DataTable(data.config);       
        $( table.table().container() ).removeClass( 'form-inline' );        
    });

    return {
        update: (data)=>{
            jQuery(node).DataTable().destroy();
            var table = jQuery(node).DataTable(data.config);
            $( table.table().container() ).removeClass( 'form-inline' );
        },
        destroy:()=>{
            jQuery(node).DataTable().destroy();
        }
    }
}